// src/lib/achievements.js
// Sistema de logros / cosméticos compartido entre el panel de Recompensas y el perfil público.
// Fuente única de verdad: sprites pixel-art, niveles, emblemas, marcos y trofeos.

// --- Niveles (espejo del backend lib/gamification.js) ---
export const LEVEL_THRESHOLDS = [
  { level: 1, xp: 0, rank: 'Novato' },   { level: 2, xp: 2000, rank: 'Novato' },
  { level: 3, xp: 5000, rank: 'Aprendiz' }, { level: 4, xp: 10000, rank: 'Avanzado' },
  { level: 5, xp: 18000, rank: 'Avanzado' }, { level: 6, xp: 28000, rank: 'Experto' },
  { level: 7, xp: 40000, rank: 'Experto' }, { level: 8, xp: 55000, rank: 'Maestro' },
  { level: 9, xp: 72000, rank: 'Maestro' }, { level: 10, xp: 100000, rank: 'Élite' },
];

export function levelInfo(xp = 0) {
  let cur = LEVEL_THRESHOLDS[0], next = null;
  for (let i = 0; i < LEVEL_THRESHOLDS.length; i++) {
    if (xp >= LEVEL_THRESHOLDS[i].xp) { cur = LEVEL_THRESHOLDS[i]; next = LEVEL_THRESHOLDS[i + 1] || null; }
  }
  const floor = cur.xp, ceil = next ? next.xp : cur.xp;
  const pct = next ? Math.min(100, Math.round(((xp - floor) / (ceil - floor)) * 100)) : 100;
  return { level: cur.level, rank: cur.rank, floor, ceil, pct, toNext: next ? ceil - xp : 0, isMax: !next };
}
export function levelColor(level = 1) {
  if (level >= 10) return '#f4511e';
  if (level >= 8)  return '#8e24aa';
  if (level >= 6)  return '#e53935';
  if (level >= 4)  return '#0091ea';
  if (level >= 2)  return '#00b248';
  return '#8a9bb0';
}

export const initials = (s = '') => s.slice(0, 2).toUpperCase();
const AVATAR_COLORS = ['#0091ea', '#00b248', '#e53935', '#8e24aa', '#f4511e', '#039be5', '#43a047', '#d81b60'];
export const avatarColor = (s = '') => AVATAR_COLORS[(s.charCodeAt(0) || 0) % AVATAR_COLORS.length];

// --- Pixel-art (sprites por código, sin GIFs) ---
export function shade(hex, amt) {
  const n = parseInt(hex.slice(1), 16);
  const c = (v) => Math.max(0, Math.min(255, v + amt));
  const r = c((n >> 16) & 255), g = c((n >> 8) & 255), b = c(n & 255);
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
}
export const SPRITES = {
  check: [
    '...........', '.........oo', '........o##', '.......o##o', 'o.....o##o.',
    'o#o..o##o..', 'o##oo##o...', '.o####o....', '..o##o.....', '...oo......', '...........',
  ],
  flame: [
    '.....o.....', '....o#o....', '....o#o....', '...o#*#o...', '...o#*#o...',
    '..o#***#o..', '..o#***#o..', '.o#*****#o.', '.o#*****#o.', '..o#***#o..', '...ooooo...',
  ],
  rocket: [
    '.....o.....', '....o#o....', '....o#o....', '...o#*#o...', '...o#*#o...',
    '...o#*#o...', '..o##*##o..', '.o#o.o.o#o.', '.oo.....oo.', '....o#o....', '...o#o#o...',
  ],
  shield: [
    '.ooooooooo.', '.o#######o.', '.o##***##o.', '.o#*#*#*#o.', '.o#*###*#o.',
    '.o#*###*#o.', '.o##*#*##o.', '..o#####o..', '...o###o...', '....o#o....', '.....o.....',
  ],
  star: [
    '.....o.....', '....o#o....', '....o#o....', '....###....', 'ooo#####ooo',
    '.o#######o.', '..o#####o..', '..o#####o..', '.o##o#o##o.', 'o#o..o..o#o', '.o.......o.',
  ],
  badge: [
    'ooooooooooo', 'o#########o', 'o#ooo#*#*#o', 'o#o#o#####o', 'o#ooo#*#*#o',
    'o#########o', 'o#*#*#*#*#o', 'o#########o', 'o#*#*#*#*#o', 'o#########o', 'ooooooooooo',
  ],
  gem: [
    '...........', '..ooooooo..', '.o#o#o#o#o.', 'o#########o', '.o#######o.',
    '..o#####o..', '...o###o...', '....o#o....', '.....o.....', '...........', '...........',
  ],
  crown: [
    '...........', '.o.......o.', 'o#o..o..o#o', 'o#o.o#o.o#o', 'o#o.o#o.o#o',
    'o#ooo#ooo#o', 'o#########o', 'o#*#*#*#*#o', 'o#########o', 'ooooooooooo', '...........',
  ],
  coin: [
    '...ooooo...', '..o#####o..', '.o#######o.', 'o#########o', 'o####*####o',
    'o###*#*###o', 'o####*####o', 'o#########o', '.o#######o.', '..o#####o..', '...ooooo...',
  ],
  bolt: [
    '.....o##o..', '....o##o...', '...o##o....', '..o##o.....', '.o######o..',
    '...o##o....', '..o##o.....', '.o##o......', 'o##o.......', 'o#o........', 'o..........',
  ],
  heart: [
    '...oo.oo...', '..o#####o..', '.o#######o.', '.o#*#####o.', '..o#####o..',
    '...o###o...', '....o#o....', '.....o.....', '...........', '...........', '...........',
  ],
  cup: [
    '.ooooooooo.', 'oo#######oo', 'o#o#####o#o', 'o#o#####o#o', 'oo#######oo',
    '.o#######o.', '..o#####o..', '...o###o...', '....o#o....', '...o###o...', '..ooooooo..',
  ],
  medal: [
    '...oo.oo...', '...##.##...', '...##.##...', '...ooooo...', '..o#####o..',
    '.o##*#*##o.', '.o#*###*#o.', '.o##*#*##o.', '..o#####o..', '...ooooo...', '...........',
  ],
  chart: [
    '...........', '...........', '........oo.', '........##.', '.....oo.##.',
    '.....##.##.', '..oo.##.##.', '..##.##.##.', '..##.##.##.', 'ooooooooooo', '...........',
  ],
  mystery: [
    '...ooooo...', '..o#####o..', '.o##...##o.', '.oo....o#o.', '.......o#o.',
    '......o#o..', '.....o#o...', '.....##....', '.....oo....', '.....##....', '.....##....',
  ],
};

// --- Emblemas y marcos (cosméticos por progresión) ---
export const EMBLEMS = [
  { key: 'photo',  color: '#8a9bb0', label: 'Tu foto',  req: 'Siempre',       unlock: () => true },
  { key: 'flame',  color: '#ff6b35', label: 'Llama',    req: 'Racha 7 días',  unlock: (u) => (u.streak || 0) >= 7 },
  { key: 'rocket', color: '#f4511e', label: 'Cohete',   req: '50 trades',     unlock: (u) => (u.trades || 0) >= 50 },
  { key: 'star',   color: '#f0b90b', label: 'Estrella', req: '10.000 XP',     unlock: (u) => (u.xp || 0) >= 10000 },
  { key: 'shield', color: '#00b248', label: 'Escudo',   req: 'Verificado',    unlock: (u) => !!u.verified },
  { key: 'bolt',   color: '#facc15', label: 'Rayo',     req: 'Racha 30 días', unlock: (u) => (u.streak || 0) >= 30 },
  { key: 'gem',    color: '#22d3ee', label: 'Gema',     req: '200 trades',    unlock: (u) => (u.trades || 0) >= 200 },
  { key: 'cup',    color: '#ffd700', label: 'Copa',     req: '500 trades',    unlock: (u) => (u.trades || 0) >= 500 },
  { key: 'crown',  color: '#d946ef', label: 'Corona',   req: 'Nivel 10',      unlock: (u) => (u.level || 1) >= 10 },
];
export const FRAMES = [
  { key: 'basic',   label: 'Básico',     req: 'Siempre',          unlock: () => true },
  { key: 'neon',    label: 'Neón',       req: 'Nivel 3',          unlock: (u) => (u.level || 1) >= 3 },
  { key: 'cyan',    label: 'Cian',       req: 'Nivel 5',          unlock: (u) => (u.level || 1) >= 5 },
  { key: 'gold',    label: 'Oro',        req: 'Nivel 7',          unlock: (u) => (u.level || 1) >= 7 },
  { key: 'magenta', label: 'Magenta',    req: 'Nivel 9',          unlock: (u) => (u.level || 1) >= 9 },
  { key: 'legend',  label: 'Legendario', req: 'Nivel 10 · Élite', unlock: (u) => (u.level || 1) >= 10 },
];
export const EMBLEM_COLOR = Object.fromEntries(EMBLEMS.map((e) => [e.key, e.color]));
export const emblemLabel = (k) => (EMBLEMS.find((e) => e.key === k) || EMBLEMS[0]).label;
export const frameLabel  = (k) => (FRAMES.find((f) => f.key === k) || FRAMES[0]).label;

// --- Trofeos por categoría con tiers; algunos son secretos (ocultos hasta desbloquear) ---
const TIER = { bronze: '#cd7f32', silver: '#c0c0c0', gold: '#ffd700', diamond: '#22d3ee', legend: '#d946ef' };

export function buildTrophies(u = {}) {
  const trades = u.trades || 0, streak = u.streak || 0, level = u.level || 1, xp = u.xp || 0;
  const rating = u.averageRating || 0, reviews = u.totalReviews || 0, kyc = u.kycLevel || 0, verified = !!u.verified;
  const wallet = !!u.walletAddress;
  return [
    { cat: 'Autocustodia', items: [
      { id: 'sc1', pix: 'shield', color: '#00d412',   label: 'Soberano',     req: 'Generá tu wallet',      unlocked: wallet },
      { id: 'sc2', pix: 'gem',    color: TIER.diamond, label: 'Tu llave',     req: 'Autocustodia activa',   unlocked: wallet },
    ]},
    { cat: 'Operaciones', items: [
      { id: 'op1', pix: 'check',  color: '#00d412',   label: 'Primer trade',     req: '1 trade',      unlocked: trades >= 1 },
      { id: 'op2', pix: 'coin',   color: TIER.bronze, label: 'Primeros pasos',   req: '5 trades',     unlocked: trades >= 5 },
      { id: 'op3', pix: 'coin',   color: TIER.silver, label: 'Mercader',         req: '10 trades',    unlocked: trades >= 10 },
      { id: 'op4', pix: 'coin',   color: TIER.gold,   label: 'Comerciante',      req: '25 trades',    unlocked: trades >= 25 },
      { id: 'op5', pix: 'rocket', color: '#f4511e',   label: 'Despegue',         req: '50 trades',    unlocked: trades >= 50 },
      { id: 'op6', pix: 'medal',  color: TIER.silver, label: 'Centurión',        req: '100 trades',   unlocked: trades >= 100 },
      { id: 'op7', pix: 'medal',  color: TIER.gold,   label: 'Doble centurión',  req: '250 trades',   unlocked: trades >= 250 },
      { id: 'op8', pix: 'cup',    color: TIER.gold,   label: 'Leyenda P2P',      req: '500 trades',   unlocked: trades >= 500 },
      { id: 'op9', pix: 'cup',    color: TIER.legend, label: 'Inmortal',         req: '1.000 trades', unlocked: trades >= 1000, secret: true },
    ]},
    { cat: 'Rachas', items: [
      { id: 'rk1', pix: 'flame', color: TIER.bronze,  label: 'Calentando',       req: '3 días',   unlocked: streak >= 3 },
      { id: 'rk2', pix: 'flame', color: '#ff6b35',    label: 'En racha',         req: '7 días',   unlocked: streak >= 7 },
      { id: 'rk3', pix: 'flame', color: TIER.gold,    label: 'Dos semanas',      req: '14 días',  unlocked: streak >= 14 },
      { id: 'rk4', pix: 'bolt',  color: '#facc15',    label: 'Imparable',        req: '30 días',  unlocked: streak >= 30 },
      { id: 'rk5', pix: 'bolt',  color: TIER.diamond, label: 'Centella',         req: '60 días',  unlocked: streak >= 60 },
      { id: 'rk6', pix: 'bolt',  color: TIER.legend,  label: 'Racha legendaria', req: '100 días', unlocked: streak >= 100, secret: true },
    ]},
    { cat: 'Progreso', items: [
      { id: 'pg1', pix: 'chart', color: '#34d399',    label: 'En ascenso',    req: 'Nivel 3',    unlocked: level >= 3 },
      { id: 'pg2', pix: 'chart', color: TIER.diamond, label: 'Escalando',     req: 'Nivel 5',    unlocked: level >= 5 },
      { id: 'pg3', pix: 'crown', color: TIER.silver,  label: 'Maestro',       req: 'Nivel 8',    unlocked: level >= 8 },
      { id: 'pg4', pix: 'crown', color: TIER.legend,  label: 'Élite',         req: 'Nivel 10',   unlocked: level >= 10 },
      { id: 'pg5', pix: 'star',  color: TIER.bronze,  label: 'Mil XP',        req: '1.000 XP',   unlocked: xp >= 1000 },
      { id: 'pg6', pix: 'star',  color: TIER.silver,  label: 'Cinco mil XP',  req: '5.000 XP',   unlocked: xp >= 5000 },
      { id: 'pg7', pix: 'star',  color: TIER.gold,    label: 'Cazador de XP', req: '10.000 XP',  unlocked: xp >= 10000 },
      { id: 'pg8', pix: 'gem',   color: TIER.diamond, label: 'Coleccionista', req: '50.000 XP',  unlocked: xp >= 50000 },
      { id: 'pg9', pix: 'gem',   color: TIER.legend,  label: 'Centurión XP',  req: '100.000 XP', unlocked: xp >= 100000, secret: true },
    ]},
    { cat: 'Reputación', items: [
      { id: 'rp1', pix: 'heart', color: TIER.bronze, label: 'Primera reseña',  req: '1 reseña',          unlocked: reviews >= 1 },
      { id: 'rp2', pix: 'heart', color: '#ec4899',   label: 'Bien valorado',   req: '4.5★ · 5 reseñas',  unlocked: rating >= 4.5 && reviews >= 5 },
      { id: 'rp3', pix: 'heart', color: TIER.gold,   label: 'Querido',         req: '25 reseñas',        unlocked: reviews >= 25 },
      { id: 'rp4', pix: 'medal', color: TIER.gold,   label: 'Cinco estrellas', req: '4.9★ · 10 reseñas', unlocked: rating >= 4.9 && reviews >= 10 },
      { id: 'rp5', pix: 'medal', color: TIER.legend, label: 'Impecable',       req: '5.0★ · 50 reseñas', unlocked: rating >= 5 && reviews >= 50, secret: true },
    ]},
    { cat: 'Verificación', items: [
      { id: 'vf1', pix: 'shield', color: '#00b248',    label: 'Vendedor verificado', req: 'Verificación', unlocked: verified },
      { id: 'vf2', pix: 'badge',  color: '#0091ea',    label: 'Identidad KYC',       req: 'KYC L1',       unlocked: kyc >= 1 },
      { id: 'vf3', pix: 'badge',  color: TIER.diamond, label: 'KYC avanzado',        req: 'KYC L2',       unlocked: kyc >= 2 },
      { id: 'vf4', pix: 'badge',  color: TIER.legend,  label: 'KYC completo',        req: 'KYC L3',       unlocked: kyc >= 3 },
    ]},
  ];
}

export function trophyStats(u) {
  const cats = buildTrophies(u);
  const all = cats.flatMap((c) => c.items);
  return { cats, all, total: all.length, unlocked: all.filter((t) => t.unlocked).length };
}

// --- Tiers / rareza estilo consola (PSN trophy cabinet) ---
export const TIER_META = {
  comun:    { label: 'Común',    color: '#9aa7b4', rarity: 'Común',      pct: 62 },
  plata:    { label: 'Plata',    color: '#c0c0c0', rarity: 'Poco común', pct: 34 },
  oro:      { label: 'Oro',      color: '#ffd700', rarity: 'Raro',       pct: 14 },
  diamante: { label: 'Diamante', color: '#22d3ee', rarity: 'Muy raro',   pct: 5 },
  leyenda:  { label: 'Leyenda',  color: '#d946ef', rarity: 'Ultra raro', pct: 1 },
};
const TIER_ORDER = ['comun', 'plata', 'oro', 'diamante', 'leyenda'];
const TIER_RANK = { comun: 1, plata: 2, oro: 3, diamante: 4, leyenda: 5 };

// El tier de un logro se infiere de su color (los tiers comparten color en buildTrophies).
export function tierOf(item) {
  switch (item.color) {
    case '#d946ef': return 'leyenda';
    case '#22d3ee': return 'diamante';
    case '#ffd700': return 'oro';
    case '#c0c0c0': return 'plata';
    default:        return 'comun';
  }
}
export function rarityOf(item) { return TIER_META[tierOf(item)]; }

export function trophyBreakdown(u) {
  const all = buildTrophies(u).flatMap((c) => c.items);
  const map = Object.fromEntries(TIER_ORDER.map((k) => [k, { key: k, total: 0, unlocked: 0, ...TIER_META[k] }]));
  all.forEach((t) => { const k = tierOf(t); map[k].total++; if (t.unlocked) map[k].unlocked++; });
  return TIER_ORDER.map((k) => map[k]);
}

// Los logros desbloqueados más raros (para la vitrina destacada).
export function featuredTrophies(u, n = 6) {
  return buildTrophies(u).flatMap((c) => c.items)
    .filter((t) => t.unlocked)
    .sort((a, b) => TIER_RANK[tierOf(b)] - TIER_RANK[tierOf(a)])
    .slice(0, n);
}

// Marco de avatar automático según el nivel (mismo umbral que FRAMES).
export function frameForLevel(level = 1) {
  if (level >= 10) return 'legend';
  if (level >= 9)  return 'magenta';
  if (level >= 7)  return 'gold';
  if (level >= 5)  return 'cyan';
  if (level >= 3)  return 'neon';
  return 'basic';
}
